// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CloseButton Component Styles */

:root {
  --scl--cms-components-closeButton-size: 20px;
  --scl--cms-components-closeButton-icon-size: 13px;
  --scl--cms-components-closeButton-default-color: var(--input-defualt);       /* #8A8B8F */
  --scl--cms-components-closeButton-hover-color: var(--input-hover);           /* rgba(0,0,0,0.8) */
  --scl--cms-components-closeButton-focus-color: var(--secondarycolors-blue400); /* #4E9FFF */
  --scl--cms-components-closeButton-stroke-width: 1.3px;
}

.scl--cms-components-closeButton {
  position: relative;
  width: var(--scl--cms-components-closeButton-size);
  height: var(--scl--cms-components-closeButton-size);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  outline: none;
  flex-shrink: 0;
  border-radius: 2px;
  transition: opacity 0.2s ease;
}

.scl--cms-components-closeButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

/* Inner SVG close icon: 13x13, centered */
.scl--cms-components-closeButton-icon {
  position: absolute;
  width: var(--scl--cms-components-closeButton-icon-size);
  height: var(--scl--cms-components-closeButton-icon-size);
  left: calc(50% - var(--scl--cms-components-closeButton-icon-size) / 2);
  top: calc(50% - var(--scl--cms-components-closeButton-icon-size) / 2);
  display: block;
  overflow: visible;
}

/* The X lines — colored via stroke */
.scl--cms-components-closeButton-icon line {
  stroke: var(--scl--cms-components-closeButton-default-color);
  stroke-width: var(--scl--cms-components-closeButton-stroke-width);
  stroke-linecap: round;
  transition: stroke 0.2s ease;
}

/* Hover */
.scl--cms-components-closeButton:hover .scl--cms-components-closeButton-icon line {
  stroke: var(--scl--cms-components-closeButton-hover-color);
}

/* Focus */
.scl--cms-components-closeButton:focus .scl--cms-components-closeButton-icon line,
.scl--cms-components-closeButton:focus-visible .scl--cms-components-closeButton-icon line {
  stroke: var(--scl--cms-components-closeButton-focus-color);
}

/* Active (pressed) */
.scl--cms-components-closeButton:active .scl--cms-components-closeButton-icon line {
  stroke: var(--scl--cms-components-closeButton-focus-color);
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/button-fs-cp/close-button-op/css/closeButton.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,4CAA4C;EAC5C,iDAAiD;EACjD,qEAAqE,QAAQ,YAAY;EACzF,iEAAiE,YAAY,oBAAoB;EACjG,6EAA6E,EAAE,YAAY;EAC3F,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,mDAAmD;EACnD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,uDAAuD;EACvD,wDAAwD;EACxD,sEAAsE;EACtE,qEAAqE;EACrE,cAAc;EACd,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,4DAA4D;EAC5D,iEAAiE;EACjE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,0DAA0D;AAC5D;;AAEA,UAAU;AACV;;EAEE,0DAA0D;AAC5D;;AAEA,qBAAqB;AACrB;EACE,0DAA0D;EAC1D,YAAY;AACd","sourcesContent":["/* CloseButton Component Styles */\n\n:root {\n  --scl--cms-components-closeButton-size: 20px;\n  --scl--cms-components-closeButton-icon-size: 13px;\n  --scl--cms-components-closeButton-default-color: var(--input-defualt);       /* #8A8B8F */\n  --scl--cms-components-closeButton-hover-color: var(--input-hover);           /* rgba(0,0,0,0.8) */\n  --scl--cms-components-closeButton-focus-color: var(--secondarycolors-blue400); /* #4E9FFF */\n  --scl--cms-components-closeButton-stroke-width: 1.3px;\n}\n\n.scl--cms-components-closeButton {\n  position: relative;\n  width: var(--scl--cms-components-closeButton-size);\n  height: var(--scl--cms-components-closeButton-size);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  padding: 0;\n  outline: none;\n  flex-shrink: 0;\n  border-radius: 2px;\n  transition: opacity 0.2s ease;\n}\n\n.scl--cms-components-closeButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Inner SVG close icon: 13x13, centered */\n.scl--cms-components-closeButton-icon {\n  position: absolute;\n  width: var(--scl--cms-components-closeButton-icon-size);\n  height: var(--scl--cms-components-closeButton-icon-size);\n  left: calc(50% - var(--scl--cms-components-closeButton-icon-size) / 2);\n  top: calc(50% - var(--scl--cms-components-closeButton-icon-size) / 2);\n  display: block;\n  overflow: visible;\n}\n\n/* The X lines — colored via stroke */\n.scl--cms-components-closeButton-icon line {\n  stroke: var(--scl--cms-components-closeButton-default-color);\n  stroke-width: var(--scl--cms-components-closeButton-stroke-width);\n  stroke-linecap: round;\n  transition: stroke 0.2s ease;\n}\n\n/* Hover */\n.scl--cms-components-closeButton:hover .scl--cms-components-closeButton-icon line {\n  stroke: var(--scl--cms-components-closeButton-hover-color);\n}\n\n/* Focus */\n.scl--cms-components-closeButton:focus .scl--cms-components-closeButton-icon line,\n.scl--cms-components-closeButton:focus-visible .scl--cms-components-closeButton-icon line {\n  stroke: var(--scl--cms-components-closeButton-focus-color);\n}\n\n/* Active (pressed) */\n.scl--cms-components-closeButton:active .scl--cms-components-closeButton-icon line {\n  stroke: var(--scl--cms-components-closeButton-focus-color);\n  opacity: 0.7;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
